import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center p-4" }
const _hoisted_2 = { class: "bg-white rounded-2xl shadow-2xl w-full max-w-md p-8" }
const _hoisted_3 = { class: "text-center mb-8" }
const _hoisted_4 = { class: "w-14 h-14 bg-[#8C0004] rounded-xl flex items-center justify-center mx-auto mb-4" }
const _hoisted_5 = {
  key: 0,
  class: "bg-red-50 border border-red-200 rounded-lg p-3"
}
const _hoisted_6 = { class: "text-sm text-red-600" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "text-sm text-gray-600 mb-4 text-center" }
const _hoisted_9 = { class: "flex justify-center gap-2" }
const _hoisted_10 = ["onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_11 = {
  key: 0,
  class: "bg-red-50 border border-red-200 rounded-lg p-3"
}
const _hoisted_12 = { class: "text-sm text-red-600" }
const _hoisted_13 = ["disabled"]

import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { Icon } from '@iconify/vue'
import { authClient, apiFor } from '../services/api'
import { useAuthStore } from '../store/auth'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter()
const authStore = useAuthStore()

const step = ref<'phone' | 'otp'>('phone')
const phone = ref('')
const otp = ref(['', '', '', '', '', ''])
const userId = ref('')
const error = ref('')
const loading = ref(false)
let otpRefs: any[] = []

const validPhone = computed(() => /^0[0-9]{9}$/.test(phone.value))
const otpComplete = computed(() => otp.value.every((v) => v))

onMounted(async () => {
  // Session déjà ouverte : aller directement au tableau de bord
  if (await authStore.checkAuth()) {
    router.push('/dashboard')
  }
})

function setOtpRef(el: any, index: number) {
  if (el) otpRefs[index] = el
}

function handleOtpInput(event: any, index: number) {
  const value = event.target.value
  if (value && !/^\d$/.test(value)) {
    otp.value[index] = ''
    return
  }
  if (value && index < 5) {
    otpRefs[index + 1]?.focus()
  }
}

function handleKeydown(event: any, index: number) {
  if (event.key === 'Backspace' && !otp.value[index] && index > 0) {
    otpRefs[index - 1]?.focus()
  }
}

function handlePaste(event: any) {
  const paste = event.clipboardData.getData('text')
  if (/^\d{6}$/.test(paste)) {
    otp.value = paste.split('')
  }
}

async function requestOtp() {
  if (!validPhone.value) return
  loading.value = true
  error.value = ''

  try {
    const { data } = await authClient.post('/partner-portal/auth/login', {
      phone: phone.value,
    })

    if (!data.userId) {
      // Réponse générique : le numéro ne correspond à aucun compte partenaire.
      // On l'annonce clairement plutôt que de bloquer l'utilisateur sur un
      // écran OTP qui n'aboutira jamais.
      error.value =
        "Aucun compte partenaire n'est associé à ce numéro. Vérifiez le numéro ou déposez une candidature."
      return
    }

    userId.value = data.userId
    step.value = 'otp'
  } catch (err: any) {
    error.value =
      err.response?.data?.message || 'Erreur lors de l\'envoi du code. Réessayez.'
  } finally {
    loading.value = false
  }
}

async function verifyOtp() {
  if (!otpComplete.value) return
  loading.value = true
  error.value = ''

  const code = otp.value.join('')

  try {
    // Ouvrir la session sur la PROD (source de vérité des comptes)…
    const { data } = await authClient.post('/partner-portal/auth/verify-otp', {
      userId: userId.value,
      otp: code,
    })

    authStore.setSession(data.user, data.partner)
    router.push('/dashboard')
  } catch (err: any) {
    error.value = err.response?.data?.message || 'Code invalide ou expiré'
    otp.value = ['', '', '', '', '', '']
    otpRefs[0]?.focus()
  } finally {
    loading.value = false
  }
}

function backToPhone() {
  step.value = 'phone'
  otp.value = ['', '', '', '', '', '']
  error.value = ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Icon), {
            icon: "solar:code-square-bold",
            class: "w-8 h-8 text-white"
          })
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-2xl font-bold text-gray-900" }, "Portail Partenaire", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm text-gray-500 mt-1" }, "API de livraison Youdégo", -1))
      ]),
      (step.value === 'phone')
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            onSubmit: _withModifiers(requestOtp, ["prevent"]),
            class: "space-y-5"
          }, [
            _createElementVNode("div", null, [
              _cache[3] || (_cache[3] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " Numéro WhatsApp ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phone).value = $event)),
                type: "tel",
                maxlength: "10",
                placeholder: "0XXXXXXXXX",
                required: "",
                class: "w-full rounded-lg border border-gray-300 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#8C0004]"
              }, null, 512), [
                [_vModelText, phone.value]
              ]),
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-xs text-gray-500 mt-2" }, " Le numéro associé à votre compte partenaire. Vous recevrez un code de connexion sur WhatsApp. ", -1))
            ]),
            (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(error.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "submit",
              disabled: !validPhone.value || loading.value,
              class: "w-full px-6 py-3 rounded-lg bg-[#8C0004] text-white font-medium hover:bg-red-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
            }, [
              (loading.value)
                ? (_openBlock(), _createBlock(_unref(Icon), {
                    key: 0,
                    icon: "svg-spinners:ring-resize",
                    class: "w-4 h-4"
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(loading.value ? 'Envoi...' : 'Recevoir le code'), 1)
            ], 8, _hoisted_7)
          ], 32))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _withModifiers(verifyOtp, ["prevent"]),
            class: "space-y-5"
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_8, [
                _cache[5] || (_cache[5] = _createTextVNode(" Entrez le code à 6 chiffres envoyé au ", -1)),
                _createElementVNode("strong", null, _toDisplayString(phone.value), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (_, i) => {
                  return _withDirectives(_createElementVNode("input", {
                    key: i,
                    ref_for: true,
                    ref: (el) => setOtpRef(el, i),
                    "onUpdate:modelValue": ($event: any) => ((otp.value[i]) = $event),
                    onInput: ($event: any) => (handleOtpInput($event, i)),
                    onKeydown: ($event: any) => (handleKeydown($event, i)),
                    onPaste: handlePaste,
                    type: "text",
                    inputmode: "numeric",
                    maxlength: "1",
                    class: "w-11 h-13 py-3 text-center text-xl font-bold rounded-lg border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#8C0004] focus:border-transparent"
                  }, null, 40, _hoisted_10), [
                    [_vModelText, otp.value[i]]
                  ])
                }), 64))
              ])
            ]),
            (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(error.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "submit",
              disabled: !otpComplete.value || loading.value,
              class: "w-full px-6 py-3 rounded-lg bg-[#8C0004] text-white font-medium hover:bg-red-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
            }, [
              (loading.value)
                ? (_openBlock(), _createBlock(_unref(Icon), {
                    key: 0,
                    icon: "svg-spinners:ring-resize",
                    class: "w-4 h-4"
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(loading.value ? 'Vérification...' : 'Se connecter'), 1)
            ], 8, _hoisted_13),
            _createElementVNode("button", {
              type: "button",
              onClick: backToPhone,
              class: "w-full px-6 py-2 rounded-lg border border-gray-300 text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors"
            }, " Changer de numéro ")
          ], 32)),
      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-center text-xs text-gray-400 mt-8" }, [
        _createTextVNode(" Pas encore partenaire ? "),
        _createElementVNode("a", {
          href: "https://youdego.app/partenaire",
          class: "text-[#8C0004] hover:underline"
        }, " Déposer une candidature ")
      ], -1))
    ])
  ]))
}
}

})